module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/milano.0dd08076dc3068cb69ef79b3fbb3dc54.jpg";